import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import accountReducer from "./accountReducer";
import menuReducer from "./menuReducer";
import notificationsReducer from "./notificationsReducer";

const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    account: accountReducer,
    notifications: notificationsReducer,
    visibleMenu: menuReducer,
    form: formReducer,
  });

export default rootReducer;
